import { useState } from 'react';
import { Popover } from '@mui/material';
import { Typography } from '@design-system/components/typography/typography';
import { Chip } from '@design-system/components/chip/chip';
import { sprinkles } from '@design-system/sprinkles.css';
import {
  BundleItemType,
  useGetCollectionParentOffersQuery,
} from 'generated/graphql';
import { LiteCollection } from '../collections.domain';
import { CollectionTag } from './collectionTag';
import { mapRawOffersToOffersDetails } from '../../collection/pricing/pricing.model';
import * as styles from './collectionOffersTag.css';

type CollectionOffersTagProps = Pick<LiteCollection, 'type' | 'programId'>;

export const CollectionOffersTag = ({
  type,
  programId,
}: CollectionOffersTagProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const { data } = useGetCollectionParentOffersQuery({
    variables: {
      input: { itemType: BundleItemType.Program, itemId: programId },
    },
    skip: anchorEl === null,
  });

  const offers = mapRawOffersToOffersDetails(data?.parentBundlesByItem || []);
  const isOpen = anchorEl !== null && offers.length > 0;

  return (
    <>
      <div
        className={styles.wrapper}
        onMouseEnter={(e) => setAnchorEl(e.currentTarget)}
        onMouseLeave={() => setAnchorEl(null)}
      >
        <CollectionTag type={type} />
      </div>
      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        disableRestoreFocus
        sx={{ pointerEvents: 'none' }}
      >
        <div className={styles.content}>
          <Typography
            variant="body"
            size="small"
            fontWeight="normal"
            color="N-100"
          >
            Program is part of Offers:
          </Typography>
          <div className={styles.chips}>
            {offers.map(({ id, title, bgColor, opacity }) => (
              <Chip
                key={id}
                readonly={true}
                label={title}
                className={sprinkles({
                  bg: { hover: bgColor, lightMode: bgColor },
                  opacity,
                })}
              />
            ))}
          </div>
        </div>
      </Popover>
    </>
  );
};
